import { isElementOpened } from "./helpers";
import { CSSClassnames } from "./ts/enum";

export default (buttons: HTMLElement[]) => {
  const eventHandlers: DisposableEventListener[] = Array.from(buttons).reduce(
    (eventHandlers: DisposableEventListener[], button: HTMLElement) => {
      const contentId = (button as HTMLElement).dataset["faqCollapsibleTarget"];
      const contentElement = dom.querySelector(`#${contentId}`);

      if (isElementOpened(button as HTMLElement)) {
        toggleContent(contentElement);
      }

      const clickHandler = () => {
        toggleContent(button);
        toggleContent(contentElement);
      };

      button.addEventListener("click", clickHandler);

      eventHandlers.push([button as HTMLElement, clickHandler]);

      return eventHandlers;
    },
    []
  );

  return function disposeCallback() {
    eventHandlers.forEach(([button, eventHandler]) => {
      button.removeEventListener("click", eventHandler);
    });
  };
};

export const toggleContent = elem => {
  const { classList } = elem;

  if (isElementOpened(elem)) {
    classList.remove(CSSClassnames.OPENED);
  } else {
    classList.add(CSSClassnames.OPENED);
  }
};
